import { AdminLayout } from "@opendash/core";
import { useParams } from "@opendash/router";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import {
  TicketContextProvider,
  useTicketManager,
} from "../../features/tickets";
import { TicketDetailWrapper } from "../../features/tickets/_shared/components/TicketDetailWrapper";

/**
 * @description Displays a page with detailed information about a single ticket.
 * @param id Needs the objectId of the ticket in navigation (/ticket/{objectId})
 */
export const TicketDetailPage = observer(() => {
  const params = useParams();

  const ticketManager = useTicketManager({
    filters: {
      ticket: { attribute: "objectId", value: params["id"] },
    },
  });
  const [ticketData] = ticketManager.data;

  useEffect(() => {
    ticketManager.fetchTickets();
  }, []);

  return (
    <AdminLayout contentPadding>
      {ticketData?.ticket?.id && (
        <TicketContextProvider value={ticketData}>
          <TicketDetailWrapper ticketManager={ticketManager} />
        </TicketContextProvider>
      )}
    </AdminLayout>
  );
});
